import * as cons from "../const";

export const setStatistics = data => ({
    type: cons.SET_STATISTICS,
    payload: data
});
